import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export class LierConsultationPlaceLabelsKeys {
  public fermer = 'avis.lierConsultationPlace.fermer';
  public intro = 'avis.lierConsultationPlace.intro';
  public referenceAvisLabel = 'avis.lierConsultationPlace.referenceAvis';
  public objetLabel = 'avis.lierConsultationPlace.objet';
  public familleLabel = 'avis.lierConsultationPlace.famille';
  public refConsultationInfo = 'avis.lierConsultationPlace.refConsultationInfo';
  public refConsultationHelp = 'avis.lierConsultationPlace.refConsultationHelp';
  public valider = 'avis.lierConsultationPlace.valider';
  public annuler = 'avis.lierConsultationPlace.annuler';
}

@Component({
  selector: 'app-lier-consultation-place-modal',
  templateUrl: './lier-consultation-place-modal.component.html',
  styleUrls: ['./lier-consultation-place-modal.component.scss']
})
export class LierConsultationPlaceModalComponent implements OnInit {

  @Input()
  public referenceAvis: string;

  @Input()
  public objetAvis: string;

  @Input()
  public familleFormulaire: string;

  @Input()
  public refConsultation: string;

  public labelsKeys: LierConsultationPlaceLabelsKeys = new LierConsultationPlaceLabelsKeys();

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  exitModal(param: boolean): void {
    this.activeModal.close(param);
  }
}
